import Meeting from "../../../../model2/meeting/meeting"
import DatetimeUtils from "../../../../gd/utils/datetime-utils"
import {EventType} from "../../../../gd/const/event"

// const debug = "calendar_createMeetingEvent"
const debug = false

export default function calendar_createMeetingEvent(data: any) {
    const meeting = data instanceof Meeting ? data : new Meeting(data)

    debug && console.log(debug, 'process', meeting)

    return {
        id          : 'meeting_' + meeting.id,
        name        : meeting.name,
        projectId   : meeting.projectId,
        startDate   : meeting.startMoment ? DatetimeUtils.dateTruncTime(meeting.startMoment) : null,
        endDate     : meeting.endMoment ? DatetimeUtils.dateTruncTime(meeting.endMoment) : null,
        type        : EventType.MEETING,
        meeting     : meeting
    }
}